"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connector = void 0;

var tslib_1 = require("tslib");

var utils_1 = require("./utils");

function connector(ldClient, set, getCurrentFlags) {
  function onFlagsChange(changes) {
    var newFlags = (0, utils_1.getFlattenedFlagsFromChangeset)({
      changes: changes
    });

    if (Object.keys(newFlags).length) {
      set(tslib_1.__assign(tslib_1.__assign({}, getCurrentFlags() || {}), newFlags || {}));
    }
  }

  ldClient.on('change', onFlagsChange);
  return function () {
    ldClient.off('change', onFlagsChange);
  };
}

exports.connector = connector;